// @flow
import React, {Component}                            from 'react';
import {connect}                                     from "react-redux";
import {addToCart, showWarning, toggleNoReservation} from "../redux/actions";
import type {CartItem}                               from "../Types/Types";
import Translator                                    from "./Translator";
import ScrollArea                                    from 'react-scrollbar';
import {Item}                                        from "./Item";
import {ItemModifierModal}                           from "./ItemModifierModal";
import {GroupItem}                                   from "./GroupItem";
import {goToShopPage}                                from "../pages/Types/Dispatcher";
import PropTypes                                     from "prop-types";

export const getShowHotDrinksModal = () => {
    let showHotDrinksModal;
    try {
        showHotDrinksModal = JSON.parse(localStorage.getItem('showHotDrinksModal'))
    } catch (_e) {
        showHotDrinksModal = false;
    }

    return showHotDrinksModal;
}

const freeContainerItems = [
    {
        id:           '',
        currency:     '',
        deleted:      '',
        hidden:       '',
        image:        process.env.PUBLIC_URL + "/images/cup_v2_430x325.png",
        price:        0,
        priority:     0,
        productId:    '',
        storageStock: 0,
        subAccount:   "KIOSKOTHER",
        type:         "nonfood",
        vatType:      "Null",
        translations: [
            {
                id:         52,
                langParent: 31,
                language:   "de",
                name:       "Tasse"
            }, {
                id:         52,
                langParent: 31,
                language:   "en",
                name:       "Cup"
            }
        ]
    }, {
        id:           '',
        currency:     '',
        deleted:      '',
        hidden:       '',
        image:        process.env.PUBLIC_URL + '/images/ownCup_430x325.png',
        price:        0,
        priority:     0,
        productId:    '',
        storageStock: 0,
        subAccount:   "KIOSKOTHER",
        type:         "nonfood",
        vatType:      "Null",
        translations: [
            {
                id:         52,
                langParent: 31,
                language:   "de",
                name:       "Eigener Becher"
            }, {
                id:         52,
                langParent: 31,
                language:   "en",
                name:       "Own Cup"
            }
        ]
    }
]

class Inventory extends Component
{
    static contextTypes = {
        router: PropTypes.object.isRequired
    };

    constructor(props)
    {
        super(props);
        this.state                        = {
            listLongerThanContainer: false,
            scrollPosition:          1,
            modifierModalOpen:       false,
            mainItem:                null
        }
        this.scrollArea                   = React.createRef();
        this.handleAddToCart              = this.handleAddToCart.bind(this);
        this.determineClassNameScrollArea = this.determineClassNameScrollArea.bind(this);
        this.getFilterValues              = this.getFilterValues.bind(this);
    }

    openModal  = (item) => this.setState({
                                             modifierModalOpen: true,
                                             mainItem:          item
                                         });
    closeModal = () => this.setState({
                                         modifierModalOpen: false,
                                         mainItem:          null
                                     });

    handleAddToCart(item)
    {
        let cartItem: CartItem = {
            translations: item.translations,
            productId:    item.productId,
            id:           item.id,
            price:        item.price,
            currency:     item.currency,
            image:        item.image,
            vatType:      item.vatType
        };
        this.props.addToCart(cartItem);
    }

    render()
    {
        const {activeFilter}     = this.getFilterValues();
        const theInventory       = this;
        const showHotDrinksModal = getShowHotDrinksModal();
        const list               = this.props.inventory.list.sort(function(a, b) {
            let nameA = this.getTranslationForItem(a);
            let nameB = this.getTranslationForItem(b);

            if (parseInt(a.priority) < parseInt(b.priority)) {
                return true;
            }

            if (parseInt(a.priority) === parseInt(b.priority)) {
                return nameA.localeCompare(nameB);
            }
        }.bind(this));

        const {
                  filteredList_with,
                  filteredList_less
              } = this.groupItemsAndBuildLists(list, theInventory, showHotDrinksModal);

        const scrollArea = <ScrollArea
            ref={this.scrollArea}
            className={this.determineClassNameScrollArea()}
            contentClassName="content"
            horizontal={false}
            onScroll={this.onScroll}
            smoothScrolling={true}
        >
            <ul className="__list">
                {filteredList_with}
                {filteredList_less}
            </ul>
        </ScrollArea>;
        return (<div className="inventory-list">
            <div className="__header-wrap">
                {this.props.shop.filter.map((item, key) => {
                    if (item !== '') {
                        let className = "__header";

                        if (this.props.shop.filter.length > 1 && activeFilter === item) {
                            className += " _active";
                        }

                        return <Translator
                            key={key}
                            className={className}
                            component="div"
                            onClick={() => {
                                goToShopPage('Shop', item)
                                this.setState({scrollPosition: 1});
                                this.scrollArea.current.setState({topPosition: 0});
                            }}
                            content={'pageTitles.shopPage.' + item}
                        />
                    } else {
                        return ''
                    }
                })}
            </div>
            {scrollArea}
            {/*<i className={'__scroll-up icon icon-stayery-arrow-d'}/>*/}
            <i className={'__scroll-down icon icon-stayery-arrow-d'} />
            <ItemModifierModal
                open={showHotDrinksModal && this.state.modifierModalOpen}
                closeModal={this.closeModal}
                items={[
                    ...list.filter(item => item.productId === this.props.inventory.crossSelling['hot-drinks']),
                    ...freeContainerItems
                ]}
                mainItem={this.state.mainItem}
                getTranslationForItem={(item) => this.getTranslationForItem(item)}
                onSelect={theInventory.handleAddToCart}
                priceAsDeposit
                title={<Translator content={"modal.hotDrinks.title"} />}
                description={<Translator content={"modal.hotDrinks.description"} />}
            />
        </div>);
    }

    /**
     * Groups inventory items by their category and builds lists of rendered components.
     *
     * This method filters items based on the active filter (main category like 'food' or 'drinks')
     * and optionally by an active group (sub-category).
     *
     * If an active group is selected, only items from that group are returned and they are rendered
     * directly without group headers.
     * If no active group is selected, items are grouped by their category. Categories with
     * specific IDs are rendered as GroupItem components (clickable categories), while items
     * without a specific category (ID 'less') are rendered directly.
     *
     * @param {Array} list The sorted inventory list.
     * @param {Object} theInventory Reference to the inventory component for callbacks.
     * @param {boolean} showHotDrinksModal Flag indicating if the hot drinks modal should be shown.
     * @returns {{filteredList_with: Array, filteredList_less: Array}} Objects containing lists of rendered components.
     */
    groupItemsAndBuildLists(list, theInventory, showHotDrinksModal)
    {
        const {
                  activeFilter,
                  activeGroup
              } = this.getFilterValues();

        // Step 1: Group items by category ID
        const groups = {};
        list.forEach(item => {
            // Filter by active type (e.g., 'food', 'drinks') and exclude cross-selling items
            if (item.type === activeFilter && item.crossSelling === '') {
                const categoryId = item.category?.id || 'less';

                // If a specific group is active, skip items that don't belong to it
                if (activeGroup !== '' && `${categoryId}` !== activeGroup) {
                    // console.log('ignore', item,categoryId,activeGroup);
                    return;
                }

                if (!groups[categoryId]) {
                    groups[categoryId] = {
                        name:  item.category?.name || 'less',
                        items: []
                    };
                }
                groups[categoryId].items.push(item);
            }
        });

        const filteredList_with = [];
        const filteredList_less = [];

        // Step 2: Build the rendered lists
        Object.keys(groups).forEach(categoryId => {
            const group         = groups[categoryId];
            const renderedItems = this.buildList(group.items, theInventory, showHotDrinksModal);

            // If we are showing a specific group OR the items have no specific category ('less'),
            // we render the items directly into filteredList_less (displayed below groups).
            // Same goes for items with only one item in the category.
            if (group.items.length <= 1 || categoryId === 'less' || activeGroup !== '') {
                filteredList_less.push(...renderedItems);
            } else {
                const {
                          name:  group_name,
                          image: group_image
                      } = group.items[0].category;

                // Otherwise, render a clickable GroupItem that allows the user to drill down
                filteredList_with.push(<GroupItem
                    key={`category-${categoryId}`}
                    categoryId={categoryId}
                    name={group_name}
                    imgSrc={group_image}
                    onClick={(categoryId) => {
                        console.log('click', categoryId);
                        goToShopPage('Shop', activeFilter, categoryId)
                        this.setState({scrollPosition: 1});
                        this.scrollArea.current.setState({topPosition: 0});
                    }}
                />);
            }
        });

        return {
            filteredList_with,
            filteredList_less
        };
    }

    getFilterValues()
    {
        const optionalParams = this.context.router.route.match.params;
        const activeFilter   = optionalParams.filter ?? (this.props.shop.filter[0] ?? '');
        const activeGroup    = optionalParams.group ?? '';
        return {
            activeFilter,
            activeGroup
        };
    }

    determineClassNameScrollArea()
    {
        let classNameScrollArea = "area";
        if (this.state.listLongerThanContainer) {
            classNameScrollArea += " _listLongerThanContainer";
        }
        switch (this.state.scrollPosition) {
            case -1:
                classNameScrollArea += " _showUpArrow";
                break;
            case 0:
                classNameScrollArea += " _showUpArrow _showDownArrow";
                break;
            case 1:
                classNameScrollArea += " _showDownArrow";
                break;
            default:
                break;
        }
        return classNameScrollArea;
    }

    buildList(list, theInventory, showHotDrinksModal)
    {
        const map = list.map((item, key) => {
            let name = this.getTranslationForItem(item);

            return (<Item
                key={`product-${key}`}
                item={item}
                name={name}
                onClick={() => {
                    //todo get flag from item itself

                    console.log({

                                    showHotDrinksModal,
                                    type: item.type,
                                    bool: showHotDrinksModal && item.type === 'hot-drinks'
                                })

                    if (showHotDrinksModal && item.type === 'hot-drinks') {
                        this.openModal(item);
                    } else {
                        theInventory.handleAddToCart(item);
                    }
                }}
            />);
        });
        return map.filter(elem => elem !== null);
    }

    onScroll = (value) => {
        console.log(value);
        let containerHeight = value.containerHeight;
        let topPosition     = value.topPosition;
        let realHeight      = value.realHeight;

        let listLongerThanContainer = realHeight > containerHeight;
        let scrollPosition          = -1;
        let threshold               = 100;

        if (this.state.scrollPosition !== -1) {
            if (topPosition) {
                let b = containerHeight + topPosition < realHeight - threshold;
                if (topPosition > threshold && b) {
                    scrollPosition = 0;
                } else if (b) {
                    scrollPosition = 1;
                } else {
                    scrollPosition = -1;
                }
            } else {
                scrollPosition = 1;
            }
        }

        this.setState({
                          listLongerThanContainer: listLongerThanContainer,
                          scrollPosition:          scrollPosition
                      });
    }

    getTranslationForItem(item)
    {
        let translationString = '';

        item.translations.map((translation) => {
            if (translation.language === this.props.locale) {
                translationString = translation.name;
            }
            return '';
        });

        return translationString;
    }
}

export default connect(state => {
    return {
        inventory: state.app.inventory,
        shop:      state.app.shop,
        locale:    state.app.locale
    }
}, {
                           showWarning,
                           addToCart,
                           toggleNoReservation
                       })(Inventory);

